import { BehaviorSubject } from 'rxjs';

/**
 * Returns a BehaviorSubject
 * @param initialValue {T} The initial value.
 */
export function createSubject<T>(initialValue: T) {
  return new BehaviorSubject<T>(initialValue);
}
